export default __webpack_public_path__ + "media/images/ksa-ef5b3c4605ab1b9fc362e1817f6061eb.png";